<template>
	<div class="TextField LongTextField" :class="{ error, 'localized': field?.localized }">
		<div class="input-wrapper">
			<textarea type="text" class="input" v-model="model" @focus="onFocus" @blur="onBlur" ref="input" :disabled="disabled" :data-cy="dataCy" />
			<AITranslation v-if="field?.localized && i18nModel" :locale="locale" :fields="[{ field, value: i18nModel, id: typeName + '-' + fieldName }]" />
		</div>

		<FieldConstraintsInfo :value="model" :error="error" :min="minSize" :max="maxSize" :disabled="disabled" />
	</div>
</template>

<script>
import { field } from './FieldMixin.js'
import FieldConstraintsInfo from './FieldConstraintsInfo.vue'
import AITranslation from '../common/AITranslation.vue'
import IconAi from '@/components/common/icons/IconAi.vue';

export default {
	components: {IconAi, AITranslation, FieldConstraintsInfo },
	mixins: [ field ],
	props: {
		modelValue: [ Number, String ],
		dataCy: String,
	},
	data: () => ({
		model: null,
	}),
	computed: {
		minSize() {
			return this.validations.size?.min
		},
		maxSize() {
			return this.validations.size?.max ?? 50000
		},
	},
	watch: {
		modelValue(value) {
			this.model = value
			this.validate()
		},
	},
	methods: {
		validate() {
			this.onErrors([
				this.validateRequired(),
				this.validateMax(),
				this.validateMin(),
				this.validateRegexp(),
				this.validateProhibitRegexp(),
				this.validateIn(),
			])
		},
	},
	mounted() {
		this.model = this.modelValue
		this.validate()
	},
}
</script>

<style scoped>
.input { min-height: 80px; max-height: 1000px; width: 100%; resize: vertical; }
.info { display: flex; -webkit-box-pack: justify; justify-content: space-between; font-size: 0.875rem; margin-top: 0.5rem; color: rgb(65, 77, 99); }
.info .status.error { color: rgb(189, 0, 42); }
</style>
